/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
export abstract class MultiMonitorChromeService {
   public setWmksService(service): void {}
   public prepareDisplaysForMultimon(sessionId, agentDPI, isActive?): void {}
   public reOpenAndDoSth(doSth?): void {}
   public canEnterMultimon(): boolean {
      return false;
   }
   public isMultimonEnabled(): void {}
}
